import { Box, Typography } from '@mui/material';
import { KPI_NUMBER_OF_DAILY_HOURS } from '../../constants';

type Props = {
  pob: number;
};

export const KpiExpectedTotalHours = ({ pob }: Props) => {
  const expectedTotal = pob * KPI_NUMBER_OF_DAILY_HOURS;

  return (
    <Typography
      variant="body2"
      sx={{ fontSize: '12px', color: 'text.secondary', textAlign: 'right' }}
    >
      Expected Total:{' '}
      <Box component="span" sx={{ fontWeight: 500, color: 'text.primary' }}>
        {expectedTotal}
      </Box>{' '}
      hours (POB:{' '}
      <Box component="span" sx={{ fontWeight: 500, color: 'text.primary' }}>
        {pob}
      </Box>{' '}
      × Daily Hours:{' '}
      <Box component="span" sx={{ fontWeight: 500, color: 'text.primary' }}>
        {KPI_NUMBER_OF_DAILY_HOURS}
      </Box>
      )
    </Typography>
  );
};
